'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reselect = require('reselect');

var _propagatePropsToChildren = require('../../helpers/propagatePropsToChildren');

var _propagatePropsToChildren2 = _interopRequireDefault(_propagatePropsToChildren);

var _sagas = require('../../hocs/sagas');

var _sagas2 = _interopRequireDefault(_sagas);

var _document = require('../../sagas/document');

var _document2 = _interopRequireDefault(_document);

var _selectDocumentQuery = require('../../selectors/document/selectDocumentQuery');

var _selectDocuments = require('../../selectors/document/selectDocuments');

var _getDocument = require('../../actions/document/getDocument');

var _getDocument2 = _interopRequireDefault(_getDocument);

var _queryDocuments = require('../../actions/document/queryDocuments');

var _queryDocuments2 = _interopRequireDefault(_queryDocuments);

var _reduceDocumentQueryElement = require('../../actions/document/reduceDocumentQueryElement');

var _reduceDocumentQueryElement2 = _interopRequireDefault(_reduceDocumentQueryElement);

var _upsertDocument = require('../../actions/document/upsertDocument');

var _upsertDocument2 = _interopRequireDefault(_upsertDocument);

var _deleteDocument = require('../../actions/document/deleteDocument');

var _deleteDocument2 = _interopRequireDefault(_deleteDocument);

var _findDocument = require('../../actions/document/findDocument');

var _findDocument2 = _interopRequireDefault(_findDocument);

var _selectShareableDocuments = require('../../selectors/document/selectShareableDocuments');

var _queryShareableDocuments = require('../../actions/document/queryShareableDocuments');

var _queryShareableDocuments2 = _interopRequireDefault(_queryShareableDocuments);

var _shareUnshareDocuments = require('../../actions/document/shareUnshareDocuments');

var _shareUnshareDocuments2 = _interopRequireDefault(_shareUnshareDocuments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Document = function (_React$Component) {
    _inherits(Document, _React$Component);

    function Document() {
        _classCallCheck(this, Document);

        return _possibleConstructorReturn(this, (Document.__proto__ || Object.getPrototypeOf(Document)).apply(this, arguments));
    }

    _createClass(Document, [{
        key: 'render',
        value: function render() {
            var document = {
                doUpsertDocument: this.props.doUpsertDocument,
                doDeleteDocument: this.props.doDeleteDocument,
                doGetDocument: this.props.doGetDocument,
                doFindDocument: this.props.doFindDocument,
                doQueryDocuments: this.props.doQueryDocuments,
                doReduceDocumentQueryElement: this.props.doReduceDocumentQueryElement,
                doQueryShareableDocuments: this.props.doQueryShareableDocuments,
                doShareUnshareDocuments: this.props.doShareUnshareDocuments,
                shareableDocuments: this.props.shareableDocuments,
                documents: this.props.documents,
                query: this.props.query
            };
            return (0, _propagatePropsToChildren2.default)(this.props.children, {
                context: this.props.context,
                reference: this.props.reference,
                document: document
            });
        }
    }]);

    return Document;
}(_react2.default.Component);

var mapStateToProps = (0, _reselect.createStructuredSelector)({
    documents: (0, _selectDocuments.selectDocuments)(),
    shareableDocuments: (0, _selectShareableDocuments.selectShareableDocuments)(),
    query: (0, _selectDocumentQuery.selectDocumentQuery)()
});

function mapDispatchToProps(dispatch) {
    return {
        doUpsertDocument: function doUpsertDocument(payload) {
            return dispatch((0, _upsertDocument2.default)(payload));
        },
        doDeleteDocument: function doDeleteDocument(payload) {
            return dispatch((0, _deleteDocument2.default)(payload));
        },
        doGetDocument: function doGetDocument(payload) {
            return dispatch((0, _getDocument2.default)(payload));
        },
        doFindDocument: function doFindDocument(payload) {
            return dispatch((0, _findDocument2.default)(payload));
        },
        doQueryDocuments: function doQueryDocuments() {
            return dispatch((0, _queryDocuments2.default)());
        },
        doReduceDocumentQueryElement: function doReduceDocumentQueryElement(payload) {
            return dispatch((0, _reduceDocumentQueryElement2.default)(payload));
        },
        doQueryShareableDocuments: function doQueryShareableDocuments(payload) {
            return dispatch((0, _queryShareableDocuments2.default)(payload));
        },
        doShareUnshareDocuments: function doShareUnshareDocuments(payload) {
            return dispatch((0, _shareUnshareDocuments2.default)(payload));
        }
    };
}

var withConnect = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);

var withSaga = (0, _sagas2.default)({ key: 'document', saga: _document2.default });

exports.default = (0, _redux.compose)(withConnect, withSaga)(Document);